export const GET_MODEL_LIST = 'builderModelSlice/getModelList';
export const CREATE_MODEL = 'builderModelSlice/createModel';
